<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">契約情報</h4>	
					
                          
                              <div class="form-group">
                                  <label>会社名</label>
                                  <span>{{ company_info.contract_company_name }}</span>
                              </div>
							   <div class="form-group">
                                  <label>メールアドレス</label>
                                  <span>{{ userDetails.email }}</span>
                              </div>

                               <div class="form-group">
                                  <label>名前</label>
                                  <span>{{ userDetails.name }}</span>
                              </div>

                              
							  <div class="form-group">
                                  <label>部署</label>
                                  <span>{{ userDetails.dept }}</span>
                              </div>
							  <div class="form-group">
                                  <label>役職</label>
                                  <span>{{ userDetails.designation }}</span>
                              </div>
                               <div class="form-group">
                                  <label>電話番号</label>
                                  <span>{{ company_info.phone_no }}</span>
                              </div>

							  <div class="form-group">
                                  <label>住所</label>
                  <span>{{ company_info.address_1 }}</span>
							  </div>
                <!--
                <div class="form-group">
                                  <label>お支払い方法</label>
                                  <div>
                                    <span>{{ cardLastDigits }}</span>
                                    <base-button 
                                    @click="openPayment()"
                                    type="flat"
                                    >
                                    {{ payment_regist_label }}
                                  </base-button>
                                </div>


                              </div>
                  -->
                   <div class="form-group">
                                  <label>ご契約サイト</label>
                                  <div>
                                    <a href="/sites">サイト情報を確認</a>
                                  </div>

                              </div>
							      

							    <div class="btn-wrap form-group text-center">
									<a class="btn btn-primary btn-white" href="javascript:history.back()">戻る</a>
									<a class="btn btn-primary" :href="'/contract/' + userDetails.id + '/edit' " v-show="permission_list['plan-edit'] ? true:false" >編集</a>
                  <!--
									<button class="delete-btn btn btn-primary" @click="doDelete(userDetails.id)" v-show="permission_list['user-delete'] ? true:false" >削除</button>
                  -->
									<confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                              </div>
                          </div>
					</div>
                </div>
            </div>


            <modal :show.sync="paymentModal" class="payment-modal">
              <h4 slot="header" class="modal-title">支払い方法の登録</h4>
              
              <ul class="radio-container">
                <li>
                  <base-radio class="mb-3" name="credit"  v-model="radio" :inline="true" v-on:change="setPaymentType" readonly>
                      クレジェットカード
                  </base-radio>
                  <div class="card-icon-wrap"><img class="img-card" width="27px" src="/img/icons/credit-card.png" srcset="/img/icons/credit-card.png, /img/icons/credit-card@2x.png" /><img src="/img/icons/issure_icon.png" srcset="/img/icons/issure_icon.png,/img/icons/issure_icon@2x.png" width="247"></div>
                </li>                             
                <li>
                  <base-radio class="mb-3" name="invoice" v-model="radio" :inline="true" v-on:change="setPaymentType" readonly disabled>
                      請求書払い
                  </base-radio>
                  <div class="card-icon-wrap"><img width="32px" src="/img/icons/paper-invoice.png" srcset="/img/icons/paper-invoice.png, /img/icons/paper-invoice@2x.png" /><span>エンタープライズプランのみご利用いただけます。</span></div>
                </li>
              </ul>

                        
              <input type="hidden" name="plan" v-model="planTitle" id="plan">
              <div  v-show="isCreditCard">
              <div class="form-group">
                  <label for="">カード保有者名<span class="badge badge-required">必須</span></label>
                  <input type="text" name="card_holder_name" v-model="cardHolderName" id="card-holder-name" class="form-control" value="" placeholder="">
              </div>
              <div class="form-group">
                <!-- Card element -->
                <!--
                  <label for="">Card details</label>
                  <div id="card-element"></div>
                -->

                  <label>クレジェットカード番号<span class="badge badge-required">必須</span></label>
                  <div id="card-number"></div>
                  </div>
                  <div class="form-group">

                    <div class="form-row">
                      <div class=" col-md-4 card-expiry-wrapper">
                        <label>有効期限<span class="badge badge-required">必須</span></label>
                        <div id="card-expiry"></div>
                      </div>
                      <div class="col-md-4">
                        <label>CVC<span class="badge badge-required">必須</span></label>
                        <div id="card-cvc"></div>
                      </div>
                    </div>
                  </div>
                  
                  <div id="card-error"></div>

                           <!-- Mount the Payment Element here -->
                           <!-- <div id="payment-element"></div>-->
                        
                      </div>
              <div class="form-group text-center" v-if="!isUpdate">
                <base-button id="card-button" type="primary" @click="registerCard()">支払い方法登録</base-button>
              </div>
              <div class="form-group text-center" v-else-if="isUpdate">  
                <base-button  id="card-button" type="primary" @click="updateCard()">更新</base-button>
              </div>
            </modal>
			
		</div>
	
</template>

<script>
import ConfirmDialogue from './ConfirmDialogue.vue'
import { StripeCheckout } from '@vue-stripe/vue-stripe';
export default {
  components: {
    ConfirmDialogue,
    StripeCheckout
  },
  
	props: ['UserData', 'userSite', 'SiteContract','stripeData','companyInfo'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      userDetails: {},
      company_info:{},
      siteId:null,
      selectedSitesInfo:{},
      siteContract:{},
      radio:"credit",
      cardLastDigits: "",
      payment_regist_label:"",
      paymentModal:false,
      isCreditCard:true,
      stripeInfo:{},
      cardElement:null,
      paymentElement:null,
      cardHolderName:"",
      planTitle:"",
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      complete: false,
      state: {
        cardNumber: false,
        cardExpiry: false,
        cardCv: false
      }
		}
	},
    computed: {
    /*  isPaymentChange() {
      if(this.radio == "credit") {
        this.isCreditCard = true;
        return true;
      }
      this.isCreditCard = false;
      return false;
    },

    
*/
setPaymentType(e) {
      console.log(e);
      if(this.radio == "credit") {
        this.isCreditCard = true;
      } else {
        this.isCreditCard = false;
      }
    },
    
    isUpdate() {
      return this.cardLastDigits != "";
    },
    isSubscribed() {
      return (this.status === 'subscribed' || this.status === 'cancelled');
    },
    isCancelled() {
      return (this.status === 'cancelled');
    }
    },
	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
    this.userDetails = JSON.parse(this.UserData);
    this.company_info = JSON.parse(this.companyInfo);
    const lastFour = this.userDetails.pm_last_four;
    this.cardLastDigits = lastFour ? `**** **** **** ${lastFour}` : "";
    this.payment_regist_label = lastFour ? "変更" : "お支払い方法登録";
    this.selectedSitesInfo = JSON.parse(this.userSite);	
    this.siteContract = JSON.parse(this.SiteContract);
    this.stripeInfo = JSON.parse(this.stripeData);

    /*
    const url = '/subscription/status';
      axios.get(url)
          .then(this.setStatus);
          */
    
	},

	methods: {
   
    
    
    openPayment() {
      console.log(this.stripeInfo);
      this.modal = false;
      this.paymentModal = true;
      this.generateCardElements();
    },
    generateCardElements() {
      const elements = stripe.elements();
      elements.update({locale: 'ja'});

      const style = {
      base: {
        color: 'black',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        lineHeight: "39px",
        borderRadius:"4px",
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };

    this.cardNumber = elements.create('cardNumber', { style });
    this.cardNumber.mount('#card-number');
    this.cardNumber.addEventListener('change', event => {
        this.state.cardNumber = event.complete;
        if (event.complete) {
          this.cardExpiry.focus();
        }
        //this.onInputComplete(this.completed());
    });
    this.cardExpiry = elements.create('cardExpiry', { style });
    this.cardExpiry.mount('#card-expiry');
    this.cardExpiry.addEventListener('change', event => {
        this.state.cardExpiry = event.complete;
        if (event.complete) {
          this.cardCvc.focus();
        }
        //this.onInputComplete(this.completed());
    });

    this.cardCvc = elements.create('cardCvc', { style });
    this.cardCvc.mount('#card-cvc');
    this.cardCvc.addEventListener('change', event => {
        this.state.cardCvc = event.complete;
       // this.onInputComplete(this.completed());
    });

    },

    async updateCard(e) {
      const paymentMethod = await this.getPaymentMethod(e.target);
      const url = '/subscription/update_card';
      const params = { payment_method: paymentMethod };
      axios.post(url, params)
          .then(response => {
            console.log(response)
            //location.reload();
      });
    },
    async registerCard(e) {
      const paymentMethod = await this.getPaymentMethod();
      const url = '/subscription/register_card';
      const params = {
        card_holder_name:this.cardHolderName,
        payment_method: paymentMethod

      };
      axios.post(url, params)
        .then(response => {
          console.log(response)
         // location.reload();
      }); 
    },

    async subscribe(planId) {
      const paymentMethod = await this.getPaymentMethod();
      const url = '/subscription/subscribe';
     
        console.log(paymentMethod)
        const params = {
          payment_method: paymentMethod,
          site_id: this.selectedSite,
          site_domain: this.selectedDomain,
          plan_id: planId,
        };
        axios.post(url, params)
          .then(response => {
            console.log(response)
            //location.reload();
        }); 
    },
setStatus(response) {

this.status = response.data.status;
this.details = response.data.details;

},

async getPaymentMethod() {
      const clientSecret = this.stripeInfo.intent.client_secret;
      console.log(this.stripeInfo.intent)
      const { setupIntent, error } = await stripe.confirmCardSetup(
          clientSecret, {
              payment_method: {
                  card: this.cardNumber,
                  billing_details: { name: this.cardHolderName }
              }
          }
      );
      if (error) {
          console.log(error);
      } else {
        console.log("setupIntent:", setupIntent)
          return setupIntent.payment_method;
      }
    },


		// Our method to GET results from a Laravel endpoint
		async doDelete(id) {
      var confirmDialog = this.$refs.confirmDialogue;
      const ok = await confirmDialog.show({
          title: 'ユーザ一を削除',
          message: 'ユーザ一を削除しますか？',
          okButton: 'はい',
          cancelButton: 'いいえ'
      })
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      try {
        if (ok) {
            this.deleteUser(id);
        } 
      }
      catch(error){

      }
		},
		deleteUser(id) {
          this.loading = true;
      this.errors = {};
      this.error = false;
      axios.post('/users/' + id , {
		  '_method':'DELETE',
      		id:id
      	}).then(response => {
        this.loading = false;
        //this.info = response.data.info;
         this.categories = response.data.result;
         this.$toast("削除しました", {
            //timeout: false,
            toastClassName: "toaster"
        });
        //this.id = response.data.result.id;
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          //this.info = error.response.data.info;
          this.$toast(error.response.data.info, {
			      toastClassName: "toaster error"
          })
          this.error = true;
           this.loading = false;
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、削除できませんでした。ページをリロードしてください")
        }
      });
        }
	}

}
</script>

<style scoped>

h4 { margin-bottom:20px}

.form-group {
  margin-bottom:1rem;
}

.form-group label {
  font-weight:bold;
}
.form-group label,
.form-group .card-body span
 {
  font-size:14px;
  line-height:24px;
}
.form-group .card-body span {
  display:block;
  padding:5px 0 5px 20px;
  color: #757575;
}

.form-group button,
.form-group a {
padding-left:20px;
}

label {
    font-size: 14px;
    color: #424242;
    font-weight: 500;
}

.payment-modal .plan-detail li{
  width: 300px;
  border:none;
}

.payment-modal label.title{
font-size: .9rem;
color: #212121;
font-weight: 700;
display: block;
border:none;
text-align:left;
}

.btn-wrap {
  padding-top: 20px;
  padding-bottom: 20px;
}
.btn-wrap span {
  display:block;
  padding: 10px;
  border: 1px solid #757575;
  border-radius: 4px;
  background: #EAECF0;
  width: 90%;
  margin:auto;
  text-align:center;
}

.payment-modal .form-group {
  margin-bottom:50px;
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

ul li {
  width: 49%;
  margin: 0 0.5%;
  box-sizing: border-box;
  text-align: left;
}

ul li span{
display: inline-block; vertical-align: bottom; padding-left: 15px; color: #32325d;
}
ul li img {
  max-width:100%;
}
#card-number,#card-expiry, #card-cvc
{
  border:1px solid #dee2e6;
  padding-left: 10px;
  border-radius:4px;

}
.card-expiry-wrapper {
  margin-right: 30px;
}
@media (max-width: 767px) {
  .card-expiry-wrapper {
  margin: auto auto 50px auto;
}
  ul li {
    width: 100%;
  }
}
.card-icon-wrap {
  margin: 30px auto 30px 30px;
  display:flex;
}
.img-card {
  margin-right:20px;
}
</style>